
import Component from "vue-class-component"
import Page from "@/report/pages/Page.vue"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import MetricCallout, {Metric} from "@/report/components/MetricCallout.vue"
import {Dimension} from "@/report/components/MetricDimension.vue"
import {formatMoneyTrunc} from "@/utils/formatter"
import {StateGenderBalance} from "@/report/PlanAnalytics"
import {upperCase} from "lodash"

@Component({
  name: "StateMapPage",
  components: {
    MetricCallout,
    Page,
  },
})
export default class StateMapPage extends AbstractPage {
  private dimension(sgb: StateGenderBalance, icon: string): Dimension {
    return {
      name: upperCase(sgb.gender),
      icon,
      value1: String(sgb.countMembers),
      value2: formatMoneyTrunc(sgb.averageTotalAssetsOwned, undefined),
    }
  }

  private metric(state: string): Metric {
    const data = this.lastSnapshot.stateGenderBalanceProfile[state]
    return {
      title: state,
      name1: "MEMBERS",
      name2: "AVG FUM",
      dimension1: this.dimension(data.find(d => d.gender === "Female")!, this.$icons.imFemale),
      dimension2: this.dimension(data.find(d => d.gender === "Male")!, this.$icons.imMale),
    }
  }

  get mapStyle(): {background: string} {
    return {
      background: `url(${<string>require("@/img/aus-states-map.png")}) center /contain no-repeat`,
    }
  }
}
